import axios from 'axios';
import {LocalStoreKeys} from '~/modules/Profile/constants';


export const endpoint = axios.create({
    baseURL: '/api',
    responseType: 'json',
    headers: {
        common: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    },
    timeout: 300000
});

endpoint.interceptors.request.use(async (config) => {
    if (typeof FormData !== 'undefined' && config.data instanceof FormData && config.headers) {
        const headers = config.headers as any;
        if (typeof headers.delete === 'function') {
            headers.delete('Content-Type');
        } else {
            delete headers['Content-Type'];
            delete headers['content-type'];
        }
    }
    let accessToken = localStorage.getItem(LocalStoreKeys.AccessToken);
    if (accessToken) {
        config.headers['X-Auth-Token'] = accessToken;
    }
    return config;
});
